import React, { useState } from "react";
import "../styles/CreateUserModal.css";
import API_URL from "../apiConfig";

export default function CreateUserModal({ show, onClose, student, token, onUserCreated }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (!show || !student) return null;

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setMsg("");

    // Basic validation
    if (!username || !password) {
      setError("Username and password are required.");
      setLoading(false);
      return;
    }
    if (password.length < 6) {
      setError("Password should be at least 6 characters.");
      setLoading(false);
      return;
    }

    try {
      const res = await fetch(`${API_URL}/api/students/${student.id}/create-user`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ username, password })
      });
      if (res.ok) {
        setMsg("User created successfully!");
        setUsername("");
        setPassword("");
        onUserCreated && onUserCreated();
        setTimeout(onClose, 1200);
      } else {
        const data = await res.json();
        setError(data.error || "Error creating user.");
      }
    } catch {
      setError("Server error.");
    }
    setLoading(false);
  };

  return (
    <div className="user-modal">
      <form className="user-form" onSubmit={handleSubmit}>
        <h3>Create Login for {student.name}</h3>
        <div className="user-form-group">
          <label>Username</label>
          <input
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
            autoFocus
            autoComplete="username"
          />
        </div>
        <div className="user-form-group">
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            autoComplete="new-password"
          />
        </div>
        {(msg || error) && <div className={`user-form-msg${error ? " error" : ""}`}>{msg || error}</div>}
        <div className="user-form-actions">
          <button type="submit" className="user-btn" disabled={loading}>
            {loading ? "Creating..." : "Create"}
          </button>
          <button
            type="button"
            className="user-btn user-btn-cancel"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}